import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
// GST + PAN logic for cart drawer
document.addEventListener('DOMContentLoaded', () => {
  const gstInput = document.getElementById('gst_number');
  const panInput = document.getElementById('pan_number');
  const panField = document.getElementById('pan_field');

  if (!gstInput || !panInput || !panField) return;

  // Uppercase + show PAN only when GST is entered
  gstInput.addEventListener('input', function () {
    this.value = this.value.toUpperCase();
    panField.style.display = this.value.length > 0 ? 'block' : 'none';

    if (!this.value) {
      panInput.value = '';
    }
  });

  panInput.addEventListener('input', function () {
    this.value = this.value.toUpperCase();
  });

  // Validation before checkout
  document.addEventListener('submit', function (e) {
    if (gstInput.value && gstInput.value.length !== 15) {
      alert('GST number must be exactly 15 characters');
      e.preventDefault();
      return;
    }

    if (gstInput.value && panInput.value.length !== 10) {
      alert('PAN number must be exactly 10 characters');
      e.preventDefault();
    }
  });
});
